import { render, staticRenderFns } from "./FigureBodyForm.vue?vue&type=template&id=10aa55f4&scoped=true"
import script from "./FigureBodyForm.vue?vue&type=script&lang=js"
export * from "./FigureBodyForm.vue?vue&type=script&lang=js"
import style0 from "./FigureBodyForm.vue?vue&type=style&index=0&id=10aa55f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa55f4",
  null
  
)

export default component.exports